import React, {useContext, useState} from 'react';
import ModalContainer from "../../common/modal_container";
import Flex from "../../layout/Flex";
import {actionContext} from "../../../apps/page";
import {PrivateUser} from "../../../hooks/useUser";
import api from "../../../util/api";
import swal from 'sweetalert';

import {SiteLogo, SiteLogo2} from "../../common/header";
import Btn from '../../layout/Btn';


export default function LoginModal({loginPopShow, setLoginPopShow, title}: {loginPopShow: boolean; setLoginPopShow: Function; title: string}){
    const { SetRegisterPop, MutateUser } = useContext(actionContext)
    const [submitting, setSubmitting] = useState<boolean>(false);

    async function handleAPIError(res: Response) {
        setSubmitting(false);
        const err: any = await res.json();
        swal({
            text: err,
            icon: "error",
        });
    }
    return (
        <ModalContainer show={loginPopShow}
                        setShow={setLoginPopShow}
                        closeBtn={true}
                        coinEffect={true}
                        className={'login-pop'}
        >
            <main>
                <div>
                    <header className={'logo-side'}>
                        <SiteLogo2/>
                    </header>
                    <form action="/api/user/login"
                          onSubmit={e=> {
                              e.preventDefault();
                              setSubmitting(true);
                              const formData = new FormData(e.target as HTMLFormElement);
                              api('/api/user/login', { method: "POST", body: formData })
                                  .then(res => res.json())
                                  .then((data: PrivateUser) => {
                                      setSubmitting(false);
                                      MutateUser()
                                      setLoginPopShow(false)
                                  })
                                  .catch((error) => {
                                      handleAPIError(error)
                                  })
                          }}>
                        <p>로그인 후 이용 가능합니다.</p>
                        <div className={"login-row"}>
                            <input type="text" name={'username'} placeholder={`아이디`}/>
                        </div>
                        <div className={"login-row"}>
                            <input type="password" name={'password'} placeholder={`비밀번호`}/>
                        </div>
                        
                        <Btn className='red' type={'submit'}>로그인</Btn>
                    </form>
                </div>
            </main>
        </ModalContainer>
    )
}